module.exports = __webpack_public_path__ + "static/img/17_.8f63f1d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/17_.jpg
// module id = wq5L
// module chunks = 1